import { queryClient } from '@queryClient';
import addComponent from '@utils/addComponent';
import { QueryClientProvider } from 'react-query';
import NoSpaceModal from '../components/NoSpaceModal';
import SpaceWarningModal from '../components/SpaceWarningModal';
import WartermarkModal from '../components/WartermarkModal';

export async function noSpaceWarning(): Promise<void> {
  return new Promise((resolve, reject) => {
    addComponent((remove) => (
      <QueryClientProvider client={queryClient}>
        <NoSpaceModal
          onRequestClose={() => {
            remove();
            reject();
          }}
        />
      </QueryClientProvider>
    ));
  });
}

export async function spaceWarning(): Promise<void> {
  return new Promise((resolve, reject) => {
    addComponent((remove) => (
      <SpaceWarningModal
        onConfirm={() => {
          resolve();
          remove();
        }}
        onRequestClose={() => {
          reject();
          remove();
        }}
      />
    ));
  });
}

export async function watermarkSetting({
  customEnabled,
}: { customEnabled?: boolean } = {}): Promise<{
  watermarked?: boolean;
  watermarkUrl: string;
}> {
  return new Promise((resolve, reject) => {
    addComponent((remove) => (
      <QueryClientProvider client={queryClient}>
        <WartermarkModal
          customEnabled={customEnabled}
          onRequestClose={() => {
            reject();
            remove();
          }}
          onConfirm={({ watermarked, watermarkUrl }) => {
            resolve({ watermarked, watermarkUrl });
            remove();
          }}
        />
      </QueryClientProvider>
    ));
  });
}
